import React from 'react';
import { Table } from 'reactstrap';
import { renderMarkdownToReact } from '../MarkdownText/MarkdownText';

const TableBlock = ({ headers = [], rows = [], variant = '', style = {} }) => {
    const headerList = Array.isArray(headers) ? headers : [];
    const rowList = Array.isArray(rows) ? rows : [];
    const isStriped = variant === 'striped' || variant === 'table-striped';
    const isBordered = variant === 'bordered' || variant === 'table-bordered';
    const isHover = variant === 'hover' || variant === 'table-hover';

    return (
        <div className="w-100">
            <Table responsive striped={isStriped} bordered={isBordered} hover={isHover} className="w-100" style={style}>
                {headerList.length > 0 && (
                    <thead>
                        <tr>
                            {headerList.map((h, i) => (
                                <th key={i}>{renderMarkdownToReact(String(h || ''))}</th>
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody>
                    {rowList.map((row, rIdx) => (
                        <tr key={rIdx}>
                            {Array.isArray(row) &&
                                row.map((cell, cIdx) => (
                                    <td key={cIdx}>{renderMarkdownToReact(String(cell || ''))}</td>
                                ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TableBlock;
